import React, { useMemo } from 'react'

import { MainMenuFragmentFragment } from '../../../../graphql/gatsby'
import { useSanityRoleAndContextBasedContent } from '../../../../lib/sanity'
import { filterMenuEntriesToDisplay } from '../../../../utils/sanity/documents/menuEntry'
import * as Styled from './styled'

type MainMenuEntry = NonNullable<NonNullable<MainMenuFragmentFragment['mainMenu']>[number]>
type SubMenuEntries = NonNullable<MainMenuEntry['childEntries']>
type SubMenuEntry = NonNullable<SubMenuEntries[number]>

export interface MegaMenuEntryProps {
  menuEntry: SubMenuEntry
}

export const MegaMenuEntry: React.FC<MegaMenuEntryProps> = ({ menuEntry }) => {
  const { shouldDisplayContent } = useSanityRoleAndContextBasedContent()
  const childEntries = useMemo(
    () => filterMenuEntriesToDisplay(shouldDisplayContent)(menuEntry.childEntries),
    [menuEntry.childEntries, shouldDisplayContent],
  )
  return (
    <Styled.MegaMenuListEntry>
      <Styled.MegaMenuEntryLink link={menuEntry.link}>{menuEntry.name}</Styled.MegaMenuEntryLink>
      {!!childEntries && childEntries.length > 0 && (
        <Styled.MegaMenuList>
          {childEntries.map((subMenuEntry, index) => (
            <MegaMenuEntry menuEntry={subMenuEntry} key={subMenuEntry._id || index} />
          ))}
        </Styled.MegaMenuList>
      )}
    </Styled.MegaMenuListEntry>
  )
}
